import config from "./config";
import { ClubLabel } from "../types/types";

type MarketSuffix = "NZ" | "AU" | "UK";

function getMarketSuffix(countryCode = config.countryCode): MarketSuffix {
  if (countryCode === "AU") {
    return "AU";
  }
  if (countryCode === "GB") {
    return "UK";
  }
  return "NZ";
}

export function getHiddenMarketKey(countryCode = config.countryCode) {
  return `hidden${getMarketSuffix(countryCode)}`;
}

export function getDefaultClubLabel(countryCode = config.countryCode): ClubLabel {
  return `club${getMarketSuffix(countryCode)}` as ClubLabel;
}
